import React, { useEffect } from 'react';
import { Form, Card } from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import CustomTable from 'common/Content/CustomTable';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserMatrix } from '../../redux/slice';
import { roles } from 'utilities/helpers';
import Loader from '@/common/Loader';

const UserMatrix = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParam = location.search;
  const searchParams = new URLSearchParams(searchParam);
  const role = searchParams.get('role') || '';
  const level = parseInt(searchParams.get('level') || '0', 10);
  const { userMatrix, getUserMatrixLoading } = useSelector(
    (state) => state.admin
  );

  useEffect(() => {
    console.log(
      'UserMatrix component mounted/updated. Role:',
      role,
      'Level:',
      level
    );
    console.log('Location search:', location.search);
    if (role && level) {
      const payload = { role, level };
      console.log('Fetching user matrix with payload:', payload);
      dispatch(fetchUserMatrix(payload));
    } else {
      console.log('Missing role or level. Role:', role, 'Level:', level);
    }
  }, [role, level, dispatch, location.search]);

  const transactions = userMatrix && userMatrix.length > 0 ? userMatrix : [];

  const column1 = [
    {
      title: 'Transactions',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: '100px',
      render: (text) => {
        return <b style={{ fontSize: '12px' }}>{text}</b>;
      }
    },
    {
      title: `Permissions`,
      dataIndex: 'permission',
      key: 'permission',
      ellipsis: true,
      width: '100px'
    }
  ];

  if (getUserMatrixLoading) {
    return <Loader />;
  }

  return (
    <>
      <Form form={form} layout="vertical">
        <Card
          title={<span>Permission Matrix</span>}
          className={`${styles.cardStyles_approver}`}
        >
          <p style={{ color: '#f536a5' }}>
            Role: <b>{roles(role, level)}</b> , Level: <b>{level}</b>
          </p>
          <div className={`${styles.table_row}`}>
            <CustomTable
              columns={column1}
              dataSource={transactions}
              pagination={false}
            />
          </div>
        </Card>
        <br />
        <FormItem className="text-center">
          <CustomButton
            className={styles.inwardButton}
            onClick={() => history.back()}
            type="primary"
          >
            Back
          </CustomButton>
        </FormItem>
      </Form>
    </>
  );
};

export default UserMatrix;
